import { AppRoutes } from './app/routes';

function App(): React.JSX.Element {
  return <AppRoutes />;
}

export default App;
